import React, { useState } from 'react'
import {
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Popover,
  useMediaQuery,
  Theme,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { FormProps } from '../../../types/default-types'
import { CheckboxInput, SubmitButton, Snackbar } from '../../../components'
import { str } from '../../../utils'
import { useReduxSelector } from '../../../hooks'
import { subcatCheckList, subcatCheckListV2 } from '../../../api'
import { propsAction } from '../../../store/props'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

const InfoPopover: React.FC<{
  info?: string
  anchorOrigin?: void
  transformOrigin?: void
}> = ({ anchorOrigin = {}, transformOrigin = {}, info }): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        {info && (
          <Box flex="0 0 auto" mt="-7px" ml="45px">
            <IconButton
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              color="primary"
              onClick={handlePopoverOpen}
              tabIndex={-1}
            >
              <InfoOutlinedIcon style={{ color: '#6C6C6C', fontSize: 25 }} />
            </IconButton>
            <Popover
              disableRestoreFocus
              id="mouse-over-popover"
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                ...anchorOrigin,
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                ...transformOrigin,
              }}
            >
              <Box px="22px" pt="15px" pb="18px">
                {str.normalize(info)}
              </Box>
            </Popover>
          </Box>
        )}
      </Box>
    </>
  )
}

export const CheckListVariable: React.FC<{
  list: any
  handleChangeList: (data: any) => void
  disableList: boolean
  className: any
  img: any
}> = ({ list = [], handleChangeList = () => {}, className, img = [], disableList = false }): JSX.Element => {
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(450))

  const dispatch = useDispatch()

  const {
    checklist_all: { checklist: dataCheckList, employee: dataEmployee, loaded: loadedCheckList },
  } = useReduxSelector((state) => state.props)

  const hookForm = useForm<any>({
    defaultValues: {
      10: true,
    },
    mode: 'onBlur',
  })

  const [formProps, setFormProps] = useState<FormProps<any>>({
    data: undefined,
    processed: false,
    snackbar: {
      onClose: () => setFormProps({ ...formProps, snackbar: { ...formProps.snackbar, message: undefined } }),
    },
  })

  const [all, setAll] = useState<any>(true)

  const handleChangeExAll = (show: boolean) => {
    setAll(show)
  }

  const onSubmitForm = (data: any) => {
    const checkedData: any[] = []
    // eslint-disable-next-line no-restricted-syntax
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key]
        if (value)
          checkedData.push({
            sub_cat_id: Number(key),
          })
      }
    }

    if (checkedData.length === 3) {
      setFormProps({ ...formProps, processed: true })

      if (dataEmployee.stage === 1) {
        subcatCheckList({
          ...dataEmployee.checklist,
          active_sub_cat: checkedData,
        })
          .then((res) => {
            if (res.status === 1) {
              const checklist_all = {
                loaded: false,
                employee: dataEmployee,
                checklist: { ...res.data.checklist },
              }
              dispatch(propsAction.setProps({ checklist_all }))
              setFormProps({ ...formProps, processed: false })
            } else {
              setFormProps({
                ...formProps,
                processed: false,
                snackbar: { ...formProps.snackbar, message: res.message },
              })
            }
          })
          .catch(() => {
            setFormProps({
              ...formProps,
              processed: false,
              snackbar: { ...formProps.snackbar, message: { error: ['Ошибка сервера. Попробуйте позже'] } },
            })
          })
      } else if (dataEmployee.stage === 2) {
        subcatCheckListV2({
          request_id: dataEmployee.id,
          active_sub_cat: checkedData,
        })
          .then((res) => {
            if (res.status === 1) {
              const checklist_all = {
                loaded: false,
                employee: dataEmployee,
                checklist: { ...res.data.checklist },
              }
              dispatch(propsAction.setProps({ checklist_all }))
              setFormProps({ ...formProps, processed: false })
            } else {
              setFormProps({
                ...formProps,
                processed: false,
                snackbar: { ...formProps.snackbar, message: res.message },
              })
            }
          })
          .catch(() => {
            setFormProps({
              ...formProps,
              processed: false,
              snackbar: { ...formProps.snackbar, message: { error: ['Ошибка сервера. Попробуйте позже'] } },
            })
          })
      }
    } else if (checkedData.length > 3) {
      setFormProps({
        ...formProps,
        processed: false,
        snackbar: { ...formProps.snackbar, message: { error: ['Выбрано более двух продуктов.'] } },
      })
    } else if (checkedData.length < 3) {
      setFormProps({
        ...formProps,
        processed: false,
        snackbar: { ...formProps.snackbar, message: { error: ['Выбрано менее двух продуктов.'] } },
      })
    }
  }

  const check = {
    icon: <span className={className.iconCheckVariable} />,
    checked: (
      <span className={className.iconCheckVariable}>
        <Box className={className.checkVariable} />
      </span>
    ),
    checkedDisabled: (
      <span className={className.iconCheckVariable}>
        <Box className={className.checkVariableDisabled} />
      </span>
    ),
  }

  return (
    <>
      {list && (
        <Accordion key="variable" expanded={all} onChange={() => handleChangeExAll(!all)} square={false}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
            <Box mr={2}>Выберите ещё два пункта для оценки:</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetailsQuiz}>
              <form onSubmit={hookForm.handleSubmit(onSubmitForm)} autoComplete="off" noValidate>
                <Grid container justifyContent="center">
                  {list &&
                    list.map((item: any, index: number) => {
                      return (
                        <Grid key={`variable${index}`} item xs={12} sm={6}>
                          <Box textAlign="left">
                            <CheckboxInput
                              name={`${item.id}`}
                              color="secondary"
                              label={item.name}
                              icon={check.icon}
                              checked={index === 0 ? check.checkedDisabled : check.checked}
                              disabled={index === 0 || disableList}
                              form={hookForm}
                              onChange={() => {
                                if (formProps.snackbar?.message) {
                                  setFormProps({
                                    ...formProps,
                                    snackbar: { ...formProps.snackbar, message: undefined },
                                  })
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                      )
                    })}
                  <Grid item xs={12}>
                    <Grid container justifyContent={sm ? 'center' : 'flex-start'}>
                      <Grid item>
                        <Box mb={1}>
                          <Snackbar {...formProps.snackbar} variantMessage="error" iconVisible={false} />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container justifyContent={sm ? 'center' : 'flex-start'}>
                      <Grid item>
                        <Box mt={1} mb={1}>
                          <SubmitButton
                            variant="contained"
                            color="secondary"
                            disabled={formProps.processed || disableList}
                            processed={formProps.processed}
                            className={className.btnVariable}
                            title="Перейти к заполнению"
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}
